import React from 'react'
import MiddlewareRoute from '../containers/MiddlewareRoute/MiddlewareRoute.container'

/**
 * The Middleware' page.
 */
const Middleware = props => <MiddlewareRoute {...props} />

export default Middleware
